import React, { useState, useEffect} from 'react'
import './TextArea.css'
import NotVip from './NotVip.jsx'
import AlreadyVip from './AlreadyVip.jsx'
import { formatEther } from '@ethersproject/units'
import Admin from './Admin.jsx'

const TextArea = (props) => {
  const [ isVip, setIsVip ] = useState(false);
  const [ cost, setCost ] = useState([]);
  const [ upgradeCost, setUpgradeCost ] = useState(0);
  const [ currency, setCurrency ] = useState('GLMR');
  
  useEffect(() => {
    if(props.account) {
      if(props.vipStatus > 0) {
        setIsVip(true);
        let upCost = 0; 
        const getUpgradeCost = async () => {
          if(props.vipStatus == 3) {
            return
          }
          upCost = Math.round(formatEther(await props.vip.upgradeFee(props.vipStatus + 1)));
          setUpgradeCost(upCost);
        }
        getUpgradeCost();
      }
      else {
        let baseCost = [];
        const getCost = async () => {
          for(let i = 0; i <= 2; i++) {
            baseCost[i] = Math.round(formatEther(await props.vip.price(i + 1)));
          }
          setCost(baseCost);
        }
        getCost();
      }
    }
    else {
      setIsVip(false);
    }
  }, [props.vipStatus, props.vip, props.account])

  useEffect(() => {
    if(props.chainId == '1287') {
      setCurrency('DEV');
    }
    else if(props.chainId == '1284') {
      setCurrency('GLMR');
    }
  }, [props.chainId])

  return (
    <div className="main-div">
      {
        props.displayAdmin ? <Admin vip={props.vip} account={props.account} provider={props.provider}></Admin> :
        !isVip ? <NotVip vipStatus={props.vipStatus} vip={props.vip} cost={cost} account={props.account} correctChain={props.correctChain} setPending={props.setPending} pending={props.pending} currency={currency}></NotVip>
        : <AlreadyVip vipStatus={props.vipStatus} vip={props.vip} upgradeCost={upgradeCost} account={props.account} correctChain={props.correctChain} setPending={props.setPending} pending={props.pending} currency={currency}></AlreadyVip>
      }  
    </div>
  )
}

export default TextArea